import React from 'react'
import 'animate.css/animate.compat.css';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Blogs from './components/Blogs';
import Account from './components/Account';
import PageNotFound from './components/PageNotFound';
import Header from './general/Header';
import Footer from './general/Footer';
import ScrollTop from './general/ScrollTop';
import AdminHeader from './admin/AdminHeader';
import AdminReports from './admin/AdminReports';
import AdminClients from './admin/AdminClients';
import ClientHeader from './components/ClientHeader';
import ClientReports from './components/ClientReports';
import UserClients from './components/UserClients';
import Copyright from './general/Copyright';
import Dashboard from './components/Dashboard';
import AdminDashboard from './admin/AdminDashboard';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BlogHistory from './admin/BlogHistory';

const App = () => {

  const userActive = localStorage.getItem('user');
  const userDetails = JSON.parse(userActive);
  const userId = parseInt(userDetails?.id);

  return (
    <BrowserRouter>
      <ScrollTop />

      {!userDetails && (
        <>      <Header />
          <Routes>
            <Route exact path='/' element={<Home />} />
            <Route exact path='/about' element={<About />} />
            <Route exact path='/projects' element={<Projects />} />
            <Route exact path='/blogs' element={<Blogs />} />
            <Route exact path='/contact' element={<Contact />} />
            <Route exact path='/account' element={<Account />} />
            <Route exact path='*' element={<PageNotFound />} />
          </Routes>
          <Footer />
        </>
      )}

      {userDetails && userId === 1 && (
        <>
          <AdminHeader />
          <Routes>
            <Route exact path='/' element={<AdminDashboard userDetails={userDetails} />} />
            <Route exact path='/admin/dashboard' element={<AdminDashboard userDetails={userDetails} />} />
            <Route exact path='/admin/clients' element={<AdminClients userDetails={userDetails} />} />
            <Route exact path='/admin/reports' element={<AdminReports userDetails={userDetails} />} />
            <Route exact path='/admin/blogs' element={<BlogHistory />} />
            <Route exact path='*' element={<PageNotFound />} />
          </Routes>
          <Copyright />
        </>
      )}

      {userDetails && userId !== 1 && (
        <>
          <ClientHeader />
          <Routes>
            <Route exact path='/' element={<Dashboard userDetails={userDetails} />} />
            <Route exact path='/user/dashboard' element={<Dashboard userDetails={userDetails} />} />
            <Route exact path='/user/reports' element={<ClientReports userDetails={userDetails} />} />
            <Route exact path='/user/clients' element={<UserClients userDetails={userDetails} />} />
            <Route exact path='*' element={<PageNotFound />} />
          </Routes>
          <Copyright />
        </>
      )}

    </BrowserRouter>
  );
};

export default App;
